export var TIMESTAMP_DB_UTC_OFFSET = '-04:00';
export var TIMESTAMP_MIN_WITH_OFFSET = "00:00:00.000".concat(TIMESTAMP_DB_UTC_OFFSET);
export var TIMESTAMP_MAX_WITH_OFFSET = "23:59:59.999".concat(TIMESTAMP_DB_UTC_OFFSET);